import { EditProfileContent, EditProfileForm } from "@app/account/components/";

type EditProfilePageProps = {
  onSave?: () => void;
};

export function EditProfilePage({ onSave }: EditProfilePageProps) {
  return (
    <>
      <EditProfileContent />
      <EditProfileForm onSave={onSave} />
    </>
  );
}
